import React from "react";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_KEPSEK } from "@/lib/nav";
import KalenderPendidikan from "@/components/KalenderPendidikan";

export default function KalenderPendidikanKepsek() {
  return (
    <Layout nav={NAV_KEPSEK}>
      <PageTitle title="Kalender Pendidikan" />
      <KalenderPendidikan canEdit />
    </Layout>
  );
}
